"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABELS_MAP = exports.ICONS_MAP = exports.TABLE_HEAD_COLUMNS = void 0;
const react_1 = __importDefault(require("react"));
const bs_1 = require("react-icons/bs");
const fi_1 = require("react-icons/fi");
const checkExclamation_svg_1 = __importDefault(require("@/assets/images/checkExclamation.svg"));
exports.TABLE_HEAD_COLUMNS = [
    { label: "Port", width: "15%" },
    { label: "Product", width: "15%" },
    { label: "Q1 BA GLOBAL", width: "5%" },
    { label: "Q1 BA REFORMA", width: "5%" },
    { label: "Q2 RS GLOBAL", width: "5%" },
    { label: "", width: "8%" },
];
exports.ICONS_MAP = new Map();
exports.ICONS_MAP.set("approved", react_1.default.createElement(fi_1.FiCheck, { size: 16, color: "#78BE20" }));
exports.ICONS_MAP.set("approved_with_restrictions", react_1.default.createElement("img", { src: checkExclamation_svg_1.default }));
exports.ICONS_MAP.set("homologated", react_1.default.createElement(bs_1.BsShieldCheck, { size: 16, color: "#78BE20" }));
exports.ICONS_MAP.set("on_homologation", react_1.default.createElement(fi_1.FiClock, { size: 16, color: "#FF8E00" }));
exports.ICONS_MAP.set("not_approved", react_1.default.createElement(fi_1.FiX, { size: 16, color: "#EE0000" }));
exports.LABELS_MAP = new Map();
exports.LABELS_MAP.set("approved", "Approved");
exports.LABELS_MAP.set("approved_with_restrictions", "Approved with restrictions");
exports.LABELS_MAP.set("homologated", "Homologated");
exports.LABELS_MAP.set("on_homologation", "On homologation");
exports.LABELS_MAP.set("not_approved", "Not approved");
